export function withResolvers<T = unknown, E = Error>() {
  let resolve!: (value: T) => void;
  let reject!: (error: E) => void;
  const promise = new Promise<T>((res, rej: (e: E) => void) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}
